interface IEFDragIndicatorIconProps {
  isHorizontal?: boolean
}
export function EFDragIndicatorIcon({ isHorizontal }: IEFDragIndicatorIconProps) {
  if (!isHorizontal)
    return (
      <svg
        style={{ height: '1.3rem', width: '1.3rem' }}
        width='16'
        height='17'
        viewBox='0 0 16 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M6 5.5C6.55228 5.5 7 5.05228 7 4.5C7 3.94772 6.55228 3.5 6 3.5C5.44772 3.5 5 3.94772 5 4.5C5 5.05228 5.44772 5.5 6 5.5ZM6 9.5C6.55228 9.5 7 9.05228 7 8.5C7 7.94772 6.55228 7.5 6 7.5C5.44772 7.5 5 7.94772 5 8.5C5 9.05228 5.44772 9.5 6 9.5ZM7 12.5C7 13.0523 6.55228 13.5 6 13.5C5.44772 13.5 5 13.0523 5 12.5C5 11.9477 5.44772 11.5 6 11.5C6.55228 11.5 7 11.9477 7 12.5ZM10 5.5C10.5523 5.5 11 5.05228 11 4.5C11 3.94772 10.5523 3.5 10 3.5C9.44772 3.5 9 3.94772 9 4.5C9 5.05228 9.44772 5.5 10 5.5ZM11 8.5C11 9.05228 10.5523 9.5 10 9.5C9.44772 9.5 9 9.05228 9 8.5C9 7.94772 9.44772 7.5 10 7.5C10.5523 7.5 11 7.94772 11 8.5ZM10 13.5C10.5523 13.5 11 13.0523 11 12.5C11 11.9477 10.5523 11.5 10 11.5C9.44772 11.5 9 11.9477 9 12.5C9 13.0523 9.44772 13.5 10 13.5Z'
          fill='#BDBDBD'
        />
      </svg>
    )

  return (
    <svg
      style={{ height: '1.3rem', width: '1.3rem' }}
      width='16'
      height='18'
      viewBox='0 0 16 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11 6.5C11 7.32843 11.6716 8 12.5 8C13.3284 8 14 7.32843 14 6.5C14 5.67157 13.3284 5 12.5 5C11.6716 5 11 5.67157 11 6.5ZM6.5 6.5C6.5 7.32843 7.17157 8 8 8C8.82843 8 9.5 7.32843 9.5 6.5C9.5 5.67157 8.82843 5 8 5C7.17157 5 6.5 5.67157 6.5 6.5ZM3.5 8C2.67157 8 2 7.32843 2 6.5C2 5.67157 2.67157 5 3.5 5C4.32843 5 5 5.67157 5 6.5C5 7.32843 4.32843 8 3.5 8ZM11 11.5C11 12.3284 11.6716 13 12.5 13C13.3284 13 14 12.3284 14 11.5C14 10.6716 13.3284 10 12.5 10C11.6716 10 11 10.6716 11 11.5ZM8 13C7.17157 13 6.5 12.3284 6.5 11.5C6.5 10.6716 7.17157 10 8 10C8.82843 10 9.5 10.6716 9.5 11.5C9.5 12.3284 8.82843 13 8 13ZM2 11.5C2 12.3284 2.67157 13 3.5 13C4.32843 13 5 12.3284 5 11.5C5 10.6716 4.32843 10 3.5 10C2.67157 10 2 10.6716 2 11.5Z'
        fill='#BDBDBD'
      />
    </svg>
  )
}
